import { useEffect } from 'react';

/**
 * Custom hook that handles the Escape key press to trigger a callback
 * @param callback - Function to call when Escape key is pressed
 * @param isActive - Whether the hook should be active (default: true)
 */
export const useEscapeKey = (callback: () => void, isActive: boolean = true) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        callback();
      }
    };

    if (isActive) {
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [callback, isActive]);
};
